import { makeStyles } from '@material-ui/core'
export const darkGrey = '#575757'

export const useStyles = makeStyles({
  icon: {
    width: 25,
    minWidth: 'unset !important',
    marginRight: 10,
  },
  logo: {
    maxWidth: '140px',
    maxHeight: '64px',
    width: '100px',
    cursor: 'pointer',
  },
  buttonLogout: {
    position: 'fixed',
    background: 'white',
    color: '#143A5F',
    fontSize: '11px',
    fontWeight: '500',
    padding: '.5em 4em',
    right: 9,
    top: 9,
    width: '5em',
    zIndex: 9999,
    '&:hover': {
      background: '#143A5F !important',
      color: '#ffffff !important',
    },
  },
})
